import {SortOrder} from "../sort-order";

export class DefaultAssetRepresentationFilters {
  name: string;
  description: string;
  sortField: string;
  sortOrder: SortOrder;
}
